

function Grid() {
  return ( <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <rect width="35" height="35" fill="url(#pattern0_1247_2787)"/>
    <defs>
    <pattern id="pattern0_1247_2787" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlinkHref="#image0_1247_2787" transform="scale(0.0111111)"/>
    </pattern>
    <image id="image0_1247_2787" width="90" height="90" preserveAspectRatio="none" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVR4nO3cu0rEUBhF4b9S30Ffy1Yh29LLI9p5KUwUrHwL0T5yUjsy4M5xBfcHdrJgHzNxqlMVERERERERERFV57dHNYw3NYyPpfGzNM3f/uyiHb+P67Rt40NpvK6rt8O+f/qLl5Maphf2AU1rdJ6X7f2e5D0PmXNAs7Hz3OfJbq+LbR7QbOsMT1e1uuWd/N8Perqv1Q3jx2YPSK6DHj9qdVs+IHXo2NCGCdaxoQ0TrGNDGyZYx4Y2TLCODW2YYJ2IiIiIjaF9nRKsY0MbJljHhjZMsI4NbZhgHRvaMME6NrRhgnVsaMME69jQhgnWsaENE6xjQxsmWMeGNkywjg1tmGCdiIiIiI2hfZ0SrGNDGyZYx4Y2TLCODW2YYB0b2jDBOja0YYJ1bGjDBOvY0IYJ1rGhDROsY0MbJljHhjZMsI4NbZhgnYiIiIiNoX2dEqxjQxsmWMeGNkywjg1tmGAdG9owwTo2tGGCdWxyHdtcmt57HHQuGBx6XDDYbp0lfVT1J53LWl27ALVdhLrNA5p/3RnGqU5fD6qLdrXvvof922ECddohn03H1VV7stuts+199dM/yK0f9LBsu1teF92e5IiIiIiIiIiIQvsCGWiMXaA34BkAAAAASUVORK5CYII="/>
    </defs>
    </svg>);
}

export default Grid;


